import React from "react";
import { useState, forwardRef, useEffect, useCallback } from "react";
import classNames from "classnames";
import "./twoup.style.scss";

const mobileBreakpoint = 1170;

export default forwardRef((props: any, ref: any) => {
    const [selected, setSelected] = useState(new Set([0]));
    const [windowExpanded, setWindowExpanded] = useState(true);

    const onWindowResize = useCallback(() => {
        if (!windowExpanded) {
            if (window.innerWidth >= mobileBreakpoint) {
                setWindowExpanded(true);
            }
        } else {
            if (window.innerWidth < mobileBreakpoint) {
                setWindowExpanded(false);
            }
        }
    }, [windowExpanded]);

    useEffect(() => {
        onWindowResize();
    }, []);

    useEffect(() => {
        if (window) {
            window.addEventListener("resize", onWindowResize);
        }

        if (windowExpanded) {
            // If more than one is selected open the first one
            if (selected.size > 1) {
                setSelected(new Set([0]));
            }
        }

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, [windowExpanded]);

    function openTab(id) {
        if (windowExpanded) {
            // desktop
            if (selected.has(id)) {
                setSelected(new Set());
            } else {
                setSelected(new Set([id]));
            }
        } else {
            // mobile
            if (selected.has(id)) {
                selected.delete(id);
            } else {
                selected.add(id);
            }

            setSelected(new Set(selected));
        }
    }

    const tabs = React.Children.map(props.children, (child, index) => {
        if (typeof child === "object") {
            return React.cloneElement(child, {
                tabId: index,
                onClick: openTab,
                selected: selected.has(index),
                width: (100 / props.children.length) + "%"
            });
        }
    });

    return (
        <div data-id={props.cmsId} ref={ref} className={classNames(props.editorClassObj)}>
            <div className="twoup-tabs bg-gray-200">
                {tabs && tabs}
            </div>
        </div>
    );
});